import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { BaseUnit } from '../../../theming/baseUnitDefinition';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

interface RecommendationsAdvertisementProps {
  revcontentWidgetID: string;
}

interface RecommendationsAdvertisementThemeProps {
  baseUnit: BaseUnit;
}


export const RecommendationsAdvertisement: React.FunctionComponent<RecommendationsAdvertisementProps> = props => {
  const { revcontentWidgetID } = props;
  const createStyle = (baseUnit: BaseUnit) => {
    return StyleSheet.create({
      style: {
        paddingTop: `${baseUnit * 2}px`,
        paddingLeft: `${baseUnit}px`,
        paddingRight: `${baseUnit}px`,
        [MEDIA_BREAKPOINTS.large]: {
          paddingLeft: `${baseUnit + 80}px`,
        },
      },
    });
  };

  const { baseUnit } = useTheme<RecommendationsAdvertisementThemeProps>();
  const style = createStyle(baseUnit);
  return (
    <ErrorBoundary>
      <div className={css(style.style)}>
        <div
          id="rc-widget-3d8993"
          data-rc-widget
          data-widget-host="habitat"
          data-endpoint="//trends.revcontent.com"
          data-widget-id={revcontentWidgetID}
        />
      </div>
    </ErrorBoundary>
  );
};
